"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EPSearch;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSearchUi = require("@elastic/react-search-ui");
var _searchUiAppSearchConnector = _interopRequireDefault(require("@elastic/search-ui-app-search-connector"));
var _config = require("./config");
var _searchBoxWrapper = _interopRequireDefault(require("../search-box-wrapper"));
function EPSearch({
  connectorConfig,
  ...searchBoxProps
}) {
  return /*#__PURE__*/_react.default.createElement(_reactSearchUi.SearchProvider, {
    config: {
      ..._config.config,
      apiConnector: new _searchUiAppSearchConnector.default(connectorConfig),
      trackUrlState: false
    }
  }, /*#__PURE__*/_react.default.createElement(_searchBoxWrapper.default, searchBoxProps));
}
EPSearch.propTypes = {
  connectorConfig: _propTypes.default.shape({
    searchKey: _propTypes.default.string,
    engineName: _propTypes.default.string,
    endpointBase: _propTypes.default.string
  }),
  ..._searchBoxWrapper.default.propTypes
};